import React from 'react';
import PropTypes from 'prop-types';

import { Helmet } from 'react-helmet';
import 'normalize.css';
import Header from './Header';
import Footer from './Footer';
import '../styles/master.scss';

const Layout = ({ children, openModalToggle }) => (
  <>
    <Helmet>
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        rel="preload"
        href="https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700&display=swap"
        as="style"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700&display=swap"
        rel="stylesheet"
      />
      <link
        rel="preload"
        href="https://fonts.googleapis.com/css2?family=Domine:wght@600;700&display=swap"
        as="style"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Domine:wght@600;700&display=swap"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        type="text/css"
        charset="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
    </Helmet>
    <div className="mainscroll">
      <Header openModalToggle={openModalToggle} />
      <main>{children}</main>
      <Footer openModalToggle={openModalToggle} />
    </div>
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  openModalToggle: PropTypes.func.isRequired,
};

export default Layout;
